import { render, staticRenderFns } from "./impeditive.vue?vue&type=template&id=1b16759f&scoped=true&lang=pug&"
import script from "./impeditive.vue?vue&type=script&lang=ts&"
export * from "./impeditive.vue?vue&type=script&lang=ts&"
import style0 from "./impeditive.vue?vue&type=style&index=0&id=1b16759f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b16759f",
  null
  
)

export default component.exports